<template>
    <div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'请选择宠物类型',width:'170px',clearable:true,filterable:true,ischange:true}"
                :value="petparam.type"
                :list="typelist"
                @finish="(val)=> {
                    petparam.type=val.value;
                    petparam.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择宠物品种',width:'170px',clearable:true,filterable:true,ischange:true}"
                :value="petparam.breed"
                :list="breedlist"
                @finish="(val)=> {
                    petparam.breed=val.value;
                    petparam.isshow=true;
                    petparam.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择宠物性别',width:'170px',clearable:true,filterable:true,ischange:true}"
                :value="petparam.sex"
                :list="sexlist"
                @finish="(val)=> {
                    petparam.sex=val.value;
                    petparam.isshow=true;
                    petparam.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择是否绝育',width:'170px',clearable:true,filterable:true,ischange:true}"
                :value="petparam.issterilization"
                :list="issterilization"
                @finish="(val)=> {
                    petparam.issterilization=val.value;
                    petparam.isshow=true;
                    petparam.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择销售状态',width:'170px',clearable:true,filterable:true,ischange:true}"
                :value="petparam.salestatus"
                :list="salestatus"
                @finish="(val)=> {
                    petparam.salestatus=val.value;
                    petparam.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择疫苗情况',width:'170px',clearable:true,filterable:true,ischange:true}"
                :value="petparam.vaccines"
                :list="vaccines"
                @finish="(val)=> {
                    petparam.vaccines=val.value;
                    petparam.isshow=true;
                    petparam.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择驱虫情况',width:'170px',clearable:true,filterable:true,ischange:true}"
                :value="petparam.DownMing"
                :list="downmonings"
                @finish="(val)=> {
                    petparam.DownMing=val.value;
                    petparam.isshow=true;
                    petparam.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcinput :option="{placeholder:'请输入宠物名称 / 品种',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                :value="petparam.key"
                @finish="(val)=> {
                    if(val.type=='input') {petparam.key=val.value;petparam.ischange=true;}
                    if(val.type=='change') {petparam.key=val.value;petparam.ischange=true;petparam.isshow=true;}
                    if(val.type=='keydown') GetPetInfos();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcbutton :option="{title:'搜索'}" @finish="GetPetInfos()" />
        </el-form-item>
        <el-form-item>
            <wcbutton :option="{title:'添加宠物'}" @finish="AddPet()" />
        </el-form-item>
        <el-form-item>
            <el-tooltip content="自定义显示小程序属性信息设置" placement="top">
            <wcbutton :option="{title:'属性设置'}" @finish="XcxPetAttributeSetting()" />
            </el-tooltip>
        </el-form-item>
        <el-form-item v-if="rollbackcomponent.isshow">
            <wcbutton :option="{title:'取消选择模式',type:'del'}" @finish="cannelselect()" />
        </el-form-item>

    </el-form>
    </div>

    <div class="TTL-table top20" id="table-pet-obj">
        <el-table :data="petlist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="宠物信息" align="center" v-if="pagelabel.thumb">
            <template #default="scope">
                <div class="TTL-pet-infos">
                    <wcimage :value="scope.row.thumb" :option="{size:'middle'}" />
                </div>
            </template>
            </el-table-column>
            <el-table-column label="宠物名称" align="center" v-if="pagelabel.name">
                <template #default="scope">
                <div class="TTL-pet-name">{{'【'+scope.row.breedname+'】'+scope.row.name}}</div>   
                </template> 
            </el-table-column>
            <el-table-column prop="sexname" label="性别" align="center" v-if="pagelabel.sexname"/>
            <el-table-column label="年纪" align="center" v-if="pagelabel.age">
                <template #default="scope">
                {{scope.row.age > 0 ? scope.row.age+'岁' : '小于1岁'}}
                </template>
            </el-table-column>
            <el-table-column prop="salestatusname" label="销售信息" align="center" v-if="pagelabel.salestatusname" />
            <el-table-column prop="inputtime" label="添加时间" align="center" v-if="pagelabel.inputtime" />
            <el-table-column label="操作" align="center" fixed="right" min-width="220">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'查看'}" @finish="ViewPet(scope.row.id)" v-if="!rollbackcomponent.isshow" />
                    <wcbutton :option="{title:'编辑'}" @finish="EditPets(scope.row.id)" v-if="!rollbackcomponent.isshow" class="left10"/>
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DelPet(scope.row.id)" v-if="!rollbackcomponent.isshow" class="left10"/>
                    <wcbutton :option="{title:'选择'}" @finish="selectpetinfos(scope.row)" v-if="rollbackcomponent.isshow" />
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <el-select v-model="handlevalue" placeholder="请选择操作" clearable @change="changehandle">
                    <el-option v-for="(item,index) in handleinfos" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="petparam.rows" 
                    :p="petparam.p" 
                    :rollpage="petparam.rollpage" 
                    @finish="(val)=> {
                        petparam.p=val.p;
                        petparam.rollpage=val.rollpage;
                        GetPetInfos();
                    }"
                />
            </div>
        </div>
    </div>

    <PetDetailDialog v-model="detailVisible" :pet-id="detailPetId" />

    <!-- 页面标签 -->
    <Pagelabel :value="showpagelabel" :type="'pet'" 
        @finish="(val)=> {
            showpagelabel=false;
            Getpagelabel(true);
        }" 
    />


</template>

<script>
import Pagelabel from '@/views/System/Pagelabel';
import PetDetailDialog from '@/views/Pets/components/PetDetailDialog';
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Pets';
export default {
    components:{
        Pagelabel,
        PetDetailDialog
    },
    data() {
        return {
            showpagelabel:false,
            pagelabel:{},
            detailVisible:false,
            detailPetId:'',
            petparam: {
                id:'',
                sex:'',
                breed:'',
                time:'',
                key:'',
                type:'',
                issterilization:'',
                iszhong:'',
                hairtype:'',
                bloodtype:'',
                salestatus:'',
                vaccines:'',
                DownMing:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0
            },
            breedlist:[],
            petlist:[
                {id:1,thumb:'',name:'二狗',breedname:'贵宾',sex:1,height:160,weight:20},
                {id:2,thumb:'',name:'闰土',breedname:'哈士奇',sex:2,height:160,weight:20},
                {id:3,thumb:'',name:'狗蛋',breedname:'德国牧羊犬',sex:2,height:160,weight:20},
                {id:4,thumb:'',name:'沙雕',breedname:'苏格兰牧羊犬',sex:2,height:160,weight:20},
                {id:5,thumb:'',name:'沙小雕',breedname:'蝴蝶犬',sex:1,height:160,weight:20},
                {id:6,thumb:'',name:'沙老雕',breedname:'中华田园犬',sex:1,height:160,weight:20},
            ],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除宠物'},
                {id:2,name:'批量修改宠物品种'},
                {id:3,name:'批量修改宠物性别'},
                {id:4,name:'批量编辑宠物'},
            ],
            typelist:[],         //宠物类型
            issterilization:[],  //是否绝育
            iszhong:[],          //是否中公种母
            hairtype:[],         //毛发类型
            bloodtype:[],        //血型
            salestatus:[],       //销售状态
            sexlist:[],          //宠物性别
            vaccines:[],         //疫苗情况
            downmonings:[],      //驱虫信息

            rollbackcomponent: {  //选择返回跳转
                isshow:false,     //是否显示选择按钮窗口
                baseurl:'',       //原来的component
                name:'',          //原来的component名字
                pets:'',          //宠物信息
            },
            paramlock: {
                sexlock:false,
                typelock:false,
            },

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            this.showpagelabel=true;
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.Getpagelabel();            //获取页面显示标签信息
            this.GetBreedInfos();           //获取宠物类型信息
            this.GetPetTypelist();          //获取宠物类型
            this.GetAttribute();            //获取宠物附加属性信息
            this.GetPetInfos();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                data.isselect ? "" :  this.GetPetInfos();   //获取宠物信息列表
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                
            }

            //其它组件跳转至该组件，请求执行选择宠物操作
            if(data.isselect) {
                this.rollbackcomponent.isshow=true;
                this.rollbackcomponent.baseurl=data.rollbackcomponent;
                this.rollbackcomponent.name=data.rollbackname;
                this.rollbackcomponent.pets='';

                //重置锁定
                for(var key in paramlock) this.paramlock[key]=false;
                //获取传过来要锁定的搜索项，并重新设置锁定项
                var paramlock=data.paramlock;
                if(paramlock) for(var key in paramlock) this.paramlock[key]=paramlock[key];

                //获取传过来要调整的设置参数
                var settingparam=data.paramsetting;
                if(settingparam) for(var key in settingparam) this.petparam[key]=settingparam[key];
                this.GetPetInfos(); //重新加载搜索项
                
            }
        },


        /** 获取宠物类型信息 **/
        GetBreedInfos() {
            INTERFACE_MODEL_PETS.GET_PET_BREEDS_ALL({}).then((res) => {
                 if(res.status > 0) return false;
                 this.breedlist=res.data;
                 for(var i in this.breedlist) this.breedlist[i].name=this.breedlist[i].breedname;
             });
        },


        /** 新增宠物类型 **/
        AddPetBreed() {
            var navinfo={name:'新增宠物类型',labelentry:'AddPetBreed',components:'AddPetBreed',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 添加宠物信息 **/
        AddPet() {
            var navinfo={name:'新增宠物',labelentry:'AddPet',components:'AddPet',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 系统设置 **/
        XcxPetAttributeSetting() {
            var navinfo={name:'系统设置',labelentry:'Setting',components:'Setting',isshow:false};
            var data={Method:'',name:"xcx_cate_setting"};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑宠物信息 **/
        GoEditPet(ids) {
            var navinfo={name:'编辑宠物',labelentry:'EditPet',components:'EditPet',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 批量操作 **/
        changehandle(index) {
            this.handlevalue='';
            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {

               var ids=this.GetSelectDataIds();
               if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的宠物',type:'warning'});return false;}
               if(index==1) { //批量删除宠物
                   this.DelPetInfos(ids.join(',')); 

               }else if(index==2) { //批量修改宠物类型
                   var navinfo={name:'批量修改宠物类型',labelentry:'EditPetBreedMore',components:'EditPetBreedMore',isshow:false};
                   var data={Method:'',delcomponent:'',ids:ids};
                   var obj={nav:navinfo,data:data};
                   this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理

               }else if(index==3) { //批量修改宠物性别
                   var navinfo={name:'批量修改宠物性别',labelentry:'EditPetSexMore',components:'EditPetSexMore',isshow:false};
                   var data={Method:'',delcomponent:'',ids:ids};
                   var obj={nav:navinfo,data:data};
                   this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理

               }else if(index==4) { //批量编辑宠物信息
                    if(ids.length > 10) {this.$notice({title:'消息提示',message:'单次最多只能编辑10个宠物',type:'warning'});return false;}
                    this.GoEditPet(ids.join(','));
               }

            }).catch(()=> {
                
            });
        },


        /** 查看宠物详情 **/
        ViewPet(id) {
            this.detailPetId=id;
            this.detailVisible=true;
        },


        /** 编辑宠物信息 **/
        EditPets(id) {
            this.GoEditPet(id);
        },


        /** 删除宠物 **/
        DelPet(id) {
            this.DelPetInfos(id);
        },


        //删除宠物信息
        DelPetInfos(ids) {
            INTERFACE_MODEL_PETS.DEL_PET_INFOS({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetPetInfos();
            });
        },


        //选择宠物信息返回之前的组件
        selectpetinfos(item) {
            var component=this.rollbackcomponent.baseurl;
            var name=this.rollbackcomponent.name;
            var pets=item;
            var navinfo={name:name,labelentry:component,components:component,isshow:false};
            var data={Method:'',pets:pets};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理

            //解除选择宠物模式
            this.cannelselect();
        },


        //取消选择模式
        cannelselect() {
            this.rollbackcomponent.isshow=false; //取消限制
            for(var key in this.paramlock) this.paramlock[key]=false; //解除锁定

            //重置搜索
            this.petparam.ischange=true;
            this.petparam.p=1;
            this.petparam.rollbackcomponent=10;
            this.GetPetInfos();
        },


        ///////////////////////////////////////
        ///////////////////////////////////////
        //加载宠物信息列表

        /** 获取宠物信息列表 **/
        GetPetInfos() {
            if(this.petparam.ischange) {
                this.petparam.p=1;
                this.petparam.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-pet-obj");
            this.$loading.openloading(obj);

            INTERFACE_MODEL_PETS.GET_PET_INFO_LIST(this.petparam).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.petparam.rows=res.data.count;
                 this.petlist=res.data.list;
            });
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.petlist.length;i++) this.petlist[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.petlist);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.petlist.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },



        /** 获取宠物附加属性信息 **/
        GetAttribute() {
            INTERFACE_MODEL_PETS.GET_PET_ATTRIBUTE({}).then((res) => {
                 if(res.status > 0) return false;
                 var datainfo=res.data;
                 this.sexlist=datainfo.sex; //性别信息
                 this.issterilization=datainfo.issterilization; //是否绝育信息
                 this.iszhong=datainfo.iszhong; //是否种公信息
                 this.hairtype=datainfo.hairtype; //被毛类型
                 this.bloodtype=datainfo.bloodtype; //血型
                 this.salestatus=datainfo.salestatus; //销售状态
                 this.vaccines=datainfo.vaccines; //疫苗情况
                 this.downmonings=datainfo.downmoning; //驱虫信息
            });
        },


        /** 获取宠物类型 **/
        GetPetTypelist() {
            INTERFACE_MODEL_PETS.GET_PET_Types({}).then((res) => {
                 if(res.status > 0) return false;
                 this.typelist=res.data;
            });
        },


        /** 获取列表显示 **/
        Getpagelabel(isfresh=false) {
            this.$method.GET_PAGE_LABEL_SETTING('pet',isfresh).then((res) => {
                this.pagelabel=res ? res : {};
            });
        },


        //加载宠物信息列表
        ///////////////////////////////////////
        ///////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-pet-infos {display:inline-flex;align-items: center;}
.TTL-pet-content {display:inline-block;width:calc(100% - 70px - 10px);height: 70px;margin-left:10px;font-size:0;}
.TTL-pet-name {display:inline-block;width:100%;font-size:13px;line-height: 18px;}
.TTL-pet-pettype {display:inline-block;width:100%;font-size:12px;line-height: 18px;color:#777777;margin-left:5px;letter-spacing: 1px;}
.TTL-pet-labellist {display:inline-block;width:100%;}
.TTL-pet-labels {display:inline-block;padding:5px 10px;font-size:12px;line-height:12px;letter-spacing: 1px;color:#999999;background-color: #EBEDF0;border-radius: 15px;margin-right:10px;zoom:.9}
.TTL-btn-list {display:inline-flex;}
</style>